const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

/** "today", "yesterday", "in 2 days", "3 hours ago". */
export function relative(iso: string, now = Date.now()): string {
  const diff = new Date(iso).getTime() - now;
  const abs = Math.abs(diff);
  if (abs < 3_600_000) return rtf.format(Math.round(diff / 60_000), 'minute');
  if (abs < 86_400_000) return rtf.format(Math.round(diff / 3_600_000), 'hour');
  return rtf.format(Math.round(diff / 86_400_000), 'day');
}

export function dateTime(iso: string, timeZone?: string): string {
  return new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', timeZone })
    .format(new Date(iso));
}

export function longDate(d = new Date()): string {
  return new Intl.DateTimeFormat('en-GB', { weekday: 'long', day: 'numeric', month: 'long' }).format(d);
}

/** Value for <input type="datetime-local"> in the browser's zone. */
export function toLocalInput(iso: string): string {
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromLocalInput(value: string): string {
  return new Date(value).toISOString();
}

const pad = (n: number) => String(n).padStart(2, '0');
/** Local YYYY-MM-DD and HH:MM of an ISO time (browser time zone). */
export const localDay = (iso: string) => { const d = new Date(iso); return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`; };
export const localTime = (iso: string) => { const d = new Date(iso); return `${pad(d.getHours())}:${pad(d.getMinutes())}`; };
/** ISO time for a local day (YYYY-MM-DD) and time (HH:MM). */
export const atLocal = (day: string, time: string) => new Date(`${day}T${time}`).toISOString();

/** Today, Yesterday and the five days before, for picking when a session happened. */
export function recentDays(now = new Date()): { value: string; label: string }[] {
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() - i, 12);
    const label = i === 0 ? 'Today' : i === 1 ? 'Yesterday'
      : new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }).format(d);
    return { value: localDay(d.toISOString()), label };
  });
}

/** Session length in minutes, from its start and end. */
export function minutesBetween(start: string, end: string | null): number | null {
  if (!end) return null;
  const m = Math.round((new Date(end).getTime() - new Date(start).getTime()) / 60_000);
  return m > 0 ? m : null;
}
